export enum RoleStatus {
  ALL = 'all',
  INVITED = 'invited',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
